<div class="courses-list-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">Explora Nuestros Cursos</h1>
      <p class="page-subtitle">{{getFilteredCourses().length}} cursos disponibles</p>
    </div>

    <!-- Search Bar -->
    <div class="search-bar">
      <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
        <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <input 
        type="text" 
        placeholder="Buscar cursos, instructores, temas..."
        [(ngModel)]="searchQuery"
        (ngModelChange)="searchQuery.set($event)">
    </div>
  </div>

  <!-- Categories Chips -->
  <div class="categories-section">
    <button 
      *ngFor="let category of categories"
      class="category-chip"
      [class.active]="selectedCategory() === category.id"
      (click)="selectCategory(category.id)">
      <span class="category-icon">{{category.icon}}</span>
      <span class="category-name">{{category.name}}</span>
      <span class="category-count">{{category.count}}</span>
    </button>
  </div>

  <div class="content-layout">
    <!-- Filters Sidebar -->
    <aside class="filters-sidebar" [class.show]="showFilters()">
      <div class="filters-header">
        <h3 class="filters-title">Filtros</h3>
        <div class="filters-actions">
          <button class="clear-filters" (click)="clearFilters()">
            Limpiar
          </button>
          <button class="close-filters" (click)="toggleFilters()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="filter-group">
        <h4 class="filter-label">Nivel</h4>
        <div class="filter-options">
          <label class="filter-option">
            <input 
              type="radio" 
              name="level" 
              value="all"
              [checked]="selectedLevel() === 'all'"
              (change)="selectedLevel.set('all')">
            <span>Todos los niveles</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="level" 
              value="beginner"
              [checked]="selectedLevel() === 'beginner'"
              (change)="selectedLevel.set('beginner')">
            <span>Principiante</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="level" 
              value="intermediate"
              [checked]="selectedLevel() === 'intermediate'"
              (change)="selectedLevel.set('intermediate')">
            <span>Intermedio</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="level" 
              value="advanced"
              [checked]="selectedLevel() === 'advanced'"
              (change)="selectedLevel.set('advanced')">
            <span>Avanzado</span>
          </label>
        </div>
      </div>

      <div class="filter-group">
        <h4 class="filter-label">Ordenar por</h4>
        <div class="filter-options">
          <label class="filter-option">
            <input 
              type="radio" 
              name="sort" 
              value="popular"
              [checked]="sortBy() === 'popular'"
              (change)="sortBy.set('popular')">
            <span>Más populares</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="sort" 
              value="rating"
              [checked]="sortBy() === 'rating'"
              (change)="sortBy.set('rating')">
            <span>Mejor valorados</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="sort" 
              value="newest"
              [checked]="sortBy() === 'newest'"
              (change)="sortBy.set('newest')">
            <span>Más recientes</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="sort" 
              value="price-low"
              [checked]="sortBy() === 'price-low'"
              (change)="sortBy.set('price-low')">
            <span>Precio: menor a mayor</span>
          </label>
          <label class="filter-option">
            <input 
              type="radio" 
              name="sort" 
              value="price-high"
              [checked]="sortBy() === 'price-high'"
              (change)="sortBy.set('price-high')">
            <span>Precio: mayor a menor</span>
          </label>
        </div>
      </div>
    </aside>

    <!-- Courses Grid -->
    <div class="courses-main">
      <div class="toolbar">
        <button class="filters-toggle" (click)="toggleFilters()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <line x1="4" y1="6" x2="20" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="4" y1="18" x2="20" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Filtros
        </button>

        <div class="results-info">
          <strong>{{getFilteredCourses().length}}</strong> cursos encontrados
        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-container" *ngIf="isLoading()">
        <div class="spinner-large"></div>
        <p class="loading-text">Cargando cursos...</p>
      </div>

      <div class="courses-grid" *ngIf="!isLoading() && getFilteredCourses().length > 0">
        <div 
          *ngFor="let course of getFilteredCourses()"
          class="course-card"
          (click)="goToCourse(course.id)">
          
          <div class="course-image">
            <img [src]="course.thumbnail" [alt]="course.title">
            
            <div class="course-badges">
              <span class="badge bestseller" *ngIf="course.isBestseller">Bestseller</span>
              <span class="badge new" *ngIf="course.isNew">Nuevo</span>
            </div>

            <div class="course-overlay">
              <button class="quick-view-btn">
                Ver Detalles
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="course-content">
            <div class="course-header">
              <h3 class="course-title">{{course.title}}</h3>
              <!-- <p class="course-instructor">{{course.instructor}}</p> -->
            </div>

            <div class="course-meta">
              <div class="rating">
                <span class="rating-value">{{course.rating}}</span>
                <div class="stars">
                  <svg *ngFor="let star of [1,2,3,4,5]" width="14" height="14" viewBox="0 0 24 24" [attr.fill]="star <= course.rating ? '#fbbc04' : 'none'">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" [attr.stroke]="star <= course.rating ? '#fbbc04' : '#5f6368'" stroke-width="2"/>
                  </svg>
                </div>
                <span class="reviews-count">({{formatNumber(course.reviews)}})</span>
              </div>

              <div class="students-count">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2"/>
                </svg>
                {{formatNumber(course.students)}} estudiantes
              </div>
            </div>

            <div class="course-info">
              <div class="info-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                {{course.duration}}
              </div>
              
              <span class="level-badge" [style.background]="getLevelColor(course.level)">
                {{getLevelLabel(course.level)}}
              </span>
            </div>

            <!-- <div class="course-footer">
              <div class="price-section">
                <div class="current-price">${{course.price}}</div>
                <div class="original-price" *ngIf="course.originalPrice">
                  ${{course.originalPrice}}
                </div>
                <div class="discount" *ngIf="course.originalPrice">
                  -{{getDiscount(course)}}%
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="no-results" *ngIf="!isLoading() && getFilteredCourses().length === 0">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
          <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <h3>No se encontraron cursos</h3>
        <p>Intenta ajustar los filtros o buscar algo diferente</p>
        <button class="reset-btn" (click)="clearFilters()">
          Limpiar filtros
        </button>
      </div>
    </div>
  </div>
</div>

